import './App.css';
import Body from "./Components/Body/body";
import Nav from "./Components/Nav/nav";
import LoadingScreen from "react-loading-screen";
import  { useState, useEffect } from 'react';
import logoim from './Components/Nav/logo-light 1.svg';


function App() {
  const[loading,setLoading]=useState(true);
  useEffect(() =>{
    setTimeout(() =>setLoading(false),3000);
  },[]);
  return (
    <>
      {loading===false ?(
        <>
          <Nav />
          <Body/>
        </>
      ):(
        <LoadingScreen
          loading={true}
          bgColor='#181220'
          spinnerColor='#FB3097'
          textColor='#FB3097'
          logoSrc={logoim}
        />
      )}

    </>
  );
}

export default App;
